import { provideTaiga, tuiHintOptionsProvider, tuiTextfieldOptionsProvider } from "@taiga-ui/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { ApplicationConfig, provideZoneChangeDetection, signal } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {mainInterceptor} from './shared/interceptors/main.interceptor';
import {errorInterceptor} from './shared/interceptors/error.interecepter';
import {provideToastr} from 'ngx-toastr';
import {TUI_LANGUAGE, TUI_RUSSIAN_LANGUAGE} from '@taiga-ui/i18n';
import {of} from 'rxjs';
import {NgxEditorModule} from 'ngx-editor';

const ngxEditorConfig = NgxEditorModule.forRoot({
  locals: {
    bold: 'Жирный',
    italic: 'Курсив',
    underline: 'Подчеркнутый',
    strike: 'Зачёркнутый',
    code: 'Код',
    blockquote: 'Цитата',
    bullet_list: 'Маркированный список',
    ordered_list: 'Нумерованный список',
    heading: 'Заголовок',
    h1: 'Заголовок 1',
    h2: 'Заголовок 2',
    h3: 'Заголовок 3',
    align_left: 'Влево',
    align_center: 'По центру',
    align_right: 'Вправо',
    align_justify: 'По ширине',
    text_color: 'Цвет текста',
    background_color: 'Цвет фона',
    horizontal_rule: 'Горизонтальная линия',
    format_clear: 'Очистить формат',
    insertLink: 'Вставить ссылку',
    removeLink: 'Удалить ссылку',
    insertImage: 'Вставить изображение',
    undo: 'Отменить',
    redo: 'Повторить',
    url: 'URL',
    text: 'Текст',
    openInNewTab: 'Открыть в новой вкладке',
    insert: 'Вставить',
    altText: 'Alt‑текст',
    title: 'Заголовок',
    remove: 'Удалить',
    enterValidUrl: 'Введите корректный URL'
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideTaiga(),
    provideHttpClient(
      withInterceptors([mainInterceptor, errorInterceptor])
    ),
    provideToastr(),
    provideTaiga({mode: 'light'}),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideTaiga(),
    {
      provide: TUI_LANGUAGE,
      useValue: signal(TUI_RUSSIAN_LANGUAGE),
    },
    tuiTextfieldOptionsProvider({ size: signal('m') }),
    ...(ngxEditorConfig.providers ?? []),
  ]
};
